export enum CompareType {
    Greater,
    Smaller,
    Equal,
    GreaterEqual,
    SmallerEqual,
    None,
    NotEqual
}
